<div class="absolute inset-0 flex min-w-0 flex-col overflow-hidden">
  <mat-drawer-container class="h-full flex-auto" (backdropClick)="closeDrawer()">
    <mat-drawer #matDrawer class="dark:bg-gray-900" [mode]="drawerMode" [opened]="drawerOpened" [disableClose]="true">
      <vessel-reports-sidebar></vessel-reports-sidebar>
    </mat-drawer>

    <mat-drawer-content class="flex flex-col overflow-hidden">
      <div class="flex flex-auto overflow-hidden">
        <router-outlet></router-outlet>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
